module.exports = __webpack_public_path__ + "media/images/photoswipe/default-skin-f64c3af3d0d25b9e4e003a8c03e4f70a.svg";